/* RESPONSIBLE TEAM: team-self-serve */
import type AppService from 'embercom/services/app-service';
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type Router from '@ember/routing/router-service';

export default class GuideLibraryRoute extends Route {
  @service declare appService: AppService;
  @service declare router: Router;

  async beforeModel() {
    this.router.transitionTo('apps.app.getting-started', this.appService.app.id);
  }
}
